import { v4 as uuidv4 } from 'uuid';

export const dummyBlock = {
    "bot": {
        "text": {
            "1": "dummy",
            "2": ""
        }
    },
    "dummy": true
};

export const answerTypes = {
    "Validated": "validated",
    "NotValidated": "not-validated",
    "Summarized": "summarized"
}

export const answerMethods  = {
    "FAQ": "FAQ",
    "PAGE_SEARCH": "PAGE_SEARCH"
}

export const allLikeMessage = {
    en: "Thank you for your feedback. We will use this to improve our services.",
    hi: "आपके फ़ीडबैक के लिए धन्यवाद । हम इसका उपयोग अपनी सेवाओं को बेहतर बनाने के लिए करेंगे। ",
    or: "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ। ଆମେ ଏହାକୁ ଆମର ସେବାଗୁଡ଼ିକୁ ଉନ୍ନତ କରିବା ପାଇଁ ବ୍ୟବହାର କରିବୁ।"
}

export const validatedAndNotValidatedDislikeMessage = {
    en: "Thank you for your feedback. We will use this to improve our services.         This answer was generated using the questions below. Would you like to know about any of them?",
    hi: "आपके फ़ीडबैक के लिए धन्यवाद । हम इसका उपयोग अपनी सेवाओं को बेहतर बनाने के लिए करेंगे।            यह उत्तर नीचे दिए गए प्रश्नों का उपयोग करके तैयार किया गया था। क्या आप उनमें से किसी के बारे में जानना चाहेंगे?",
    or: "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ। ଏହି ଉତ୍ତରଟି ନିମ୍ନରେ ଥିବା ପ୍ରଶ୍ନଗୁଡ଼ିକୁ ବ୍ୟବହାର କରି ସୃଷ୍ଟି କରାଯାଇଥିଲା। ଆପଣ କ’ଣ ସେମାନଙ୍କ ମଧ୍ୟରୁ କୌଣସି ବିଷୟରେ ଜାଣିବାକୁ ଚାହାଁନ୍ତି?"
}

export const summarizedAnswerTitle = { en: "This answer is yet to be validated.", hi: "इस उत्तर की पुष्टि होना अभी बाकी है" }

export const botDisclaimerMessage = {
    'en': 'Use your discretion or consult your supervisor for guidance',
    'hi': 'कृपया समझदारी से निर्णय लें या मार्गदर्शन के लिए अपनी सुपरवाइज़र से परामर्श करें।',
    'or': 'ଆପଣଙ୍କ ବିବେଚନା ବ୍ୟବହାର କରନ୍ତୁ କିମ୍ବା ମାର୍ଗଦର୍ଶନ ପାଇଁ ଆପଣଙ୍କ ସୁପରଭାଇଜରଙ୍କ ସହିତ ପରାମର୍ଶ କରନ୍ତୁ।',
    'mr': 'कृपया आपल्या विवेकबुद्धीनुसार निर्णय घ्या किंवा मार्गदर्शनासाठी आपल्या सुपरवायझरचा सल्ला घ्या.'
}
export const langDisclaimer = {
    'en': `You have selected “English". Now you can ask questions in “English" Change language  here ☰`,
    'hi': `आपने "हिंदी" भाषा चुनी है। अब आप "हिंदी" में सवाल पूछ सकते हैं । भाषा यहाँ ☰ से बदलें`,
    'or': `ଆପଣ “ଓଡିଆ” ବାଛିଲେ। ବର୍ତ୍ତମାନ ଆପଣ “ଓଡିଆ”ରେ ପ୍ରଶ୍ନ ପଚାରିପାରିବେ। ଭାଷା ବଦଳାଇବା ପାଇଁ ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ ☰`,
    'mr': `तुम्ही "मराठी" भाषा निवडली आहे. आता तुम्ही "मराठी" मध्ये प्रश्न विचारू शकता" येथे भाषा बदला ☰`
}

export const disclaimer = {
    "ASHA_DEMO": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "AWW_WCD": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Women and Child Development, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के महिला बाल विकास मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ମହିଳା ଓ ଶିଶୁ ବିକାଶ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ।"
    },
    "CHO_CTD": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "ASHA_GAVI": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "FPC_BSHS": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    },
    "ANM_POC": {
      en: "The answers provided by the AI Assistant are based on the training modules published by the Ministry of Health and Family Welfare, Government of India.",
      hi: "एआई असिस्टेंट द्वारा दिए गए उत्तर, भारत सरकार के स्वास्थ्य एवं परिवार कल्याण मंत्रालय द्वारा प्रकाशित ट्रेनिंग मॉड्यूल पर आधारित हैं।",
      or: "ଏଆଇ ସହାୟକ ଦ୍ୱାରା ପ୍ରଦାନ କୃତ ଉତ୍ତରଗୁଡ଼ିକ ଭାରତ ସରକାରଙ୍କ ସ୍ୱାସ୍ଥ୍ୟ ଓ ପରିବାର କଲ୍ୟାଣ ମନ୍ତ୍ରଣାଳୟ ଦ୍ୱାରା ପ୍ରକାଶିତ ପ୍ରଶିକ୍ଷଣ ମାଡ଼ୁଲ୍‌ଗୁଡ଼ିକ ଉପରେ ଆଧାରିତ ଅଟେ।",
      mr: "एआय असिस्टेंट दिलेली उत्तरे भारत सरकारच्या आरोग्य व कुटुंब कल्याण मंत्रालयाने प्रकाशित केलेल्या प्रशिक्षण मॉड्यूलवर आधारित आहेत."
    }
};  

export const doubt = {
    en: "Type question here",
    hi: "अपने प्रश्न यहाँ टाइप करें",
    or: "ଆପଣଙ୍କର ପ୍ରଶ୍ନଗୁଡ଼ିକ ଏଠାରେ ଟାଇପ୍ କରନ୍ତୁ",
    mr: "आपले प्रश्न येथे टाइप करा"

}
export const errorMessageObj = (datetime, userQueryObj) => {
    return {
        "_id": uuidv4(),
        "offset": -1,
        "bot": {
            "datetime": datetime,
            "text": {
                "en": "Something went wrong. Please try again.",
                "hi": "कुछ गड़बड़ हुई है। कृपया दोबारा प्रयास करें।"
            },
            "options": [],
            "suggested_questions": {},
            "sources": [],
            "success": false,
            "error": {
                "code": "303",
                "message": "Internal Server Error"
            },
            "starred": false,
            "welcome": false,
            "answer_type": ""
        },
        "user": {
            "datetime": datetime,
            "type": userQueryObj?.values[0]?.type,
            "text": userQueryObj?.values[0]?.value,
            "image": userQueryObj?.image
        }
    }
}

export const welcomeMessageBlockText = {
    html: {
      en: `<p style="display: inline-block;">👋 Hello! I am HealthVaani, your <strong>AI companion</strong>. Ask me anything about your work. Your chats are <strong>private and secure.</strong></p>`,
  
      hi: `<p style="display: inline-block;">👋 नमस्कार! मैं हेल्थवाणी हूँ, आपकी <strong>AI साथी</strong>। मुझसे अपने काम के बारे में कुछ भी पूछें। आपकी बातचीत पूरी तरह से <strong>निजी और सुरक्षित</strong> हैं।</p>`,
  
      or: `<p style="display: inline-block;">👋 ନମସ୍କାର! ମୁଁ ହେଲ୍ଥଭାନି, ଆପଣଙ୍କର <strong>AI ସାଥୀ</strong>। ଆପଣଙ୍କ କାମ ବିଷୟରେ ମୋତେ ପଚାରନ୍ତୁ। ଆପଣଙ୍କ ଚାଟ୍ <strong>ବ୍ୟକ୍ତିଗତ ଏବଂ ସୁରକ୍ଷିତ</strong>।</p>`,
  
      mr: `<p style="display: inline-block;">👋 नमस्कार! मी हेल्थवाणी, तुमचा <strong>AI सहाय्यक</strong> आहे. तुमच्या कामाशी संबंधित कोणताही प्रश्न मला विचारा. तुमचे चॅट <strong>सुरक्षित आणि गोपनीय</strong> आहेत.</p>`
    },

    markdown: {
      en: `👋 Hello! I am HealthVaani, your **AI companion**. Ask me anything about your work. Your chats are **private and secure.**`,

      hi: `👋 नमस्कार! मैं हेल्थवाणी हूँ, आपकी **AI साथी**। मुझसे अपने काम के बारे में कुछ भी पूछें। आपकी बातचीत पूरी तरह से **निजी और सुरक्षित** हैं।`,

      or: `👋 ନମସ୍କାର! ମୁଁ ହେଲ୍ଥଭାନି, ଆପଣଙ୍କର **AI ସାଥୀ**। ଆପଣଙ୍କ କାମ ବିଷୟରେ ମୋତେ ପଚାରନ୍ତୁ। ଆପଣଙ୍କ ଚାଟ୍ **ବ୍ୟକ୍ତିଗତ ଏବଂ ସୁରକ୍ଷିତ**।`,

      mr: `👋 नमस्कार! मी हेल्थवाणी, तुमचा **AI सहाय्यक** आहे. तुमच्या कामाशी संबंधित कोणताही प्रश्न मला विचारा. तुमचे चॅट **सुरक्षित आणि गोपनीय** आहेत.`
    },
  
    audio: {
      en: "Hello! I’m HealthVaani, your AI companion. Ask me anything about your work. Your chats are private and secure.",
  
      hi: "नमस्कार! मैं हेल्थवाणी हूँ, आपकी AI साथी। मुझसे अपने काम के बारे में कुछ भी पूछें। आपकी बातचीत पूरी तरह से निजी और सुरक्षित हैं।",
  
      or: "ନମସ୍କାର! ମୁଁ ହେଲ୍ଥଭାନି, ଆପଣଙ୍କର AI ସାଥୀ। ଆପଣଙ୍କ କାମ ବିଷୟରେ ମୋତେ ପଚାରନ୍ତୁ। ଆପଣଙ୍କ ଚାଟ୍ ବ୍ୟକ୍ତିଗତ ଏବଂ ସୁରକ୍ଷିତ।",
  
      mr: "नमस्कार! मी हेल्थवाणी, तुमचा AI सहाय्यक आहे. तुमच्या कामाशी संबंधित कोणताही प्रश्न मला विचारा. तुमचे चॅट सुरक्षित आणि गोपनीय आहेत."
    }
  };

export const welcomeMessageBlockTextNeGD = {
    "html": {
        "en": `<p style="display: inline-block;">Hello! I am Anganwadi Chatbot, your <strong>AI companion</strong>. Ask me anything about your work. Your chats are <strong>private and secure.</strong></p>`,
        "hi": ``,
        "or": ``,
        "mr": ``
    },
    "markdown": {
        "en": `Hello! I am Anganwadi Chatbot, your **AI companion**. Ask me anything about your work. Your chats are **private and secure.**`,
        "hi": ``,
        "or": ``,
        "mr": ``
    },
    "audio": {
        "en": "Hello! I am Anganwadi Chatbot, your AI companion. Ask me anything about your work. Your chats are private and secure.",
        "hi": "",
        "or": "",
        "mr": ""
    }
}

export const welcomeMessageBlockTextSecond = {
    html: {
      en: `<p style="display: inline-block;">🤝 If I am unable to respond, be assured your question is saved and my team will work on it.</p>`,
  
      hi: `<p style="display: inline-block;">🤝 अगर कभी मैं जवाब न दे पाऊँ, तो निश्चिंत रहें, आपका सवाल दर्ज हो गया है, और मैं हमेशा खुद को बेहतर बना रही हूँ।</p>`,
  
      or: `<p style="display: inline-block;">🤝 ଯଦି ମୁଁ ଉତ୍ତର ଦେବାକୁ ଅସମର୍ଥ, ନିଶ୍ଚିତ ହୁଅ ଯେ ତୁମର ପ୍ରଶ୍ନ ସଞ୍ଚୟ ହୋଇଛି ଏବଂ ମୋର ଟିମ୍ ଏହା ଉପରେ କାର୍ଯ୍ୟ କରିବ।</p>`,
  
      mr: `<p style="display: inline-block;">🤝 जर कधी मी उत्तर देऊ शकले नाही, तर काळजी करू नका —तुमचा प्रश्न जतन झाला आहे, आणि मी तुमच्यासाठी अधिक चांगली होण्यासाठी सतत शिकत आहे ।</p>`
    },

    markdown: {
      en: `🤝 If I am unable to respond, be assured your question is saved and my team will work on it.`,

      hi: `🤝 अगर कभी मैं जवाब न दे पाऊँ, तो निश्चिंत रहें, आपका सवाल दर्ज हो गया है, और मैं हमेशा खुद को बेहतर बना रही हूँ।`,

      or: `🤝 ଯଦି ମୁଁ ଉତ୍ତର ଦେବାକୁ ଅସମର୍ଥ, ନିଶ୍ଚିତ ହୁଅ ଯେ ତୁମର ପ୍ରଶ୍ନ ସଞ୍ଚୟ ହୋଇଛି ଏବଂ ମୋର ଟିମ୍ ଏହା ଉପରେ କାର୍ଯ୍ୟ କରିବ।`,

      mr: `🤝 जर कधी मी उत्तर देऊ शकले नाही, तर काळजी करू नका —तुमचा प्रश्न जतन झाला आहे, आणि मी तुमच्यासाठी अधिक चांगली होण्यासाठी सतत शिकत आहे ।`
    },
  
    audio: {
      en: "If I am unable to respond, be assured your question is saved and my team will work on it.",
  
      hi: "अगर कभी मैं जवाब न दे पाऊँ, तो निश्चिंत रहें, आपका सवाल दर्ज हो गया है, और मैं हमेशा खुद को बेहतर बना रही हूँ।",
  
      or: "ଯଦି ମୁଁ ଉତ୍ତର ଦେଇପାରିବି ନାହିଁ, ତେବେ ନିଶ୍ଚିତ ରୁହନ୍ତୁ ଯେ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ସେଭ୍ ହୋଇଛି ଏବଂ ମୋର ଟିମ୍ ଏହା ଉପରେ କାମ କରିବ।",
  
      mr: "जर कधी मी उत्तर देऊ शकले नाही, तर काळजी करू नका —तुमचा प्रश्न सुरक्षितपणे जतन केला जाईल आणि आमची टीम त्यावर काम करेल."
    }
  };

export const welcomeMessageBlockTextSecondNeGD = {
    "html": {
        "en": `<p style=\"display: inline-block;\">🤝 If I am unable to respond, be assured your question is saved and my team will work on it.</p>`,
        "hi": ``,
        "or": ``,
        "mr": ``
    },
    "markdown": {
        "en": `🤝 If I am unable to respond, be assured your question is saved and my team will work on it.`,
        "hi": ``,
        "or": ``,
        "mr": ``
    },
    "audio": {
        "en": "If I am unable to respond, be assured your question is saved and my team will work on it.",
        "hi": "",
        "or": "",
        "mr": ""
    }
}


export const defaultChipBlockText = {
    html: {
      en: `
        <p style="margin: 0;">
          <strong>There are several ways to ask:</strong>
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 Ask a question by speaking or typing
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 Choose one of these topics and view related questions
        </p>
      `,
  
      hi: `
        <p style="margin: 0;">
          <strong>पूछने के कई तरीके हैं:</strong>
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 बोलकर या टाइप करके सवाल पूछें
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 इनमें से कोई विषय चुनें और उससे जुड़े सवाल देखें
        </p>
      `,
  
      or: `
        <p style="margin: 0;">
          <strong>ପଚାରିବାର ଅନେକ ଉପାୟ ଅଛି:</strong>
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 କଥା କହି କିମ୍ବା ଟାଇପ୍ କରି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 ଏହି ବିଷୟଗୁଡ଼ିକ ମଧ୍ୟରୁ ଗୋଟିଏ ବାଛନ୍ତୁ ଏବଂ ସମ୍ପର୍କିତ ପ୍ରଶ୍ନ ଦେଖନ୍ତୁ
        </p>
      `,
  
      mr: `
        <p style="margin: 0;">
          <strong>प्रश्न विचारण्याचे अनेक मार्ग आहेत:</strong>
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 बोलून किंवा टाइप करून प्रश्न विचारा.
        </p>
  
        <p style="margin: 8px 0 0 0;">
          👉 खालीलपैकी एखादा विषय निवडा आणि त्यासंबंधित प्रश्न पाहा.
        </p>
      `
    },

    markdown: {
      en: `**There are several ways to ask:**\n\n👉 Ask a question by speaking or typing\n\n👉 Choose one of these topics and view related questions`,

      hi: `**पूछने के कई तरीके हैं:**\n\n👉 बोलकर या टाइप करके सवाल पूछें\n\n👉 इनमें से कोई विषय चुनें और उससे जुड़े सवाल देखें`,

      or: `**ପଚାରିବାର ଅନେକ ଉପାୟ ଅଛି:**\n\n👉 କଥା କହି କିମ୍ବା ଟାଇପ୍ କରି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ\n\n👉 ଏହି ବିଷୟଗୁଡ଼ିକ ମଧ୍ୟରୁ ଗୋଟିଏ ବାଛନ୍ତୁ ଏବଂ ସମ୍ପର୍କିତ ପ୍ରଶ୍ନ ଦେଖନ୍ତୁ`,

      mr: `**प्रश्न विचारण्याचे अनेक मार्ग आहेत:**\n\n👉 बोलून किंवा टाइप करून प्रश्न विचारा.\n\n👉 खालीलपैकी एखादा विषय निवडा आणि त्यासंबंधित प्रश्न पाहा.`
    },
  
    audio: {
      en: "There are several ways to ask: Ask a question by speaking or typing. Choose one of these topics and view related questions.",
  
      hi: "आप कोई प्रश्न पूछ सकते हैं या ग्रिड आइकन से कोई विषय चुन सकते हैं।",
  
      or: "ପଚାରିବାର ଅନେକ ଉପାୟ ଅଛି: କଥା କହି କିମ୍ବା ଟାଇପ୍ କରି ଏକ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ। ଏହି ବିଷୟଗୁଡ଼ିକ ମଧ୍ୟରୁ ଗୋଟିଏ ବାଛନ୍ତୁ ଏବଂ ସମ୍ପର୍କିତ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ।",
  
      mr: "प्रश्न विचारण्याचे अनेक मार्ग आहेत: बोलून किंवा टाइप करून प्रश्न विचारा. खालीलपैकी एखादा विषय निवडा आणि त्यासंबंधित प्रश्न पाहा."
    }
  };

export const noAnswerDefaultBlockText = {
    html: {
        en: `<p style=\"display: inline-block;\">
          If you believe your question is for an activity for your role, please try asking it in a different way or ask a different question.
        </p>`,
        hi: `<p style=\"display: inline-start;\">
        यदि आपको लगता है कि आपका प्रश्न आपके काम से संबंधित है, तो कृपया इसे अलग तरीके से पूछने का प्रयास करें या एक अलग सवाल पूछें ।
    </p>`
    },
    markdown: {
        en: `If you believe your question is for an activity for your role, please try asking it in a different way or ask a different question.`,
        hi: `यदि आपको लगता है कि आपका प्रश्न आपके काम से संबंधित है, तो कृपया इसे अलग तरीके से पूछने का प्रयास करें या एक अलग सवाल पूछें ।`
    },
    audio: {
        en: "If you believe your question is for an activity for your role, please try asking it in a different way or ask a different question.",
        hi: "यदि आपको लगता है कि आपका प्रश्न आपके काम से संबंधित है, तो कृपया इसे अलग तरीके से पूछने का प्रयास करें या एक अलग सवाल पूछें"
    }
}

export const validatedSameMessage = {
    en: "Thanks for sharing your feedback! 🙏 Share any other feedback here ☰",
    hi: "अपनी राय बताने के लिए धन्यवाद! 🙏 अन्य सुझाव या फीडबैक यहाँ ☰ दें!",
    or: "ଆପଣଙ୍କ ମତାମତ ଜଣାଇଥିବାରୁ ଧନ୍ୟବାଦ! 🙏 ଆପଣଙ୍କ ମତାମତ ଏଠାରେ ଜଣାନ୍ତୁ ☰",
    mr: "तुमचा फीडबॅक शेअर केल्याबद्दल धन्यवाद! 🙏 इतर सूचना किंवा अभिप्राय येथे द्या ☰"
}
